import { Offer } from 'common/contracts';
import { OfferType } from 'constants/enums';

import { Observable } from './observable';

class GamePortalPagesStateService {
  readonly openBlockIndex = new Observable<number | undefined>(undefined);
  readonly openItemIndex = new Observable<string | undefined>(undefined); // Format: "blockIndex-itemIndex"
  readonly hasStoreOffers = new Observable<boolean>(false);
  readonly storeOffers = new Observable<
    | {
        [OfferType.BUNDLE]?: Offer[];
        [OfferType.SPECIAL_OFFER]?: Offer[];
        [OfferType.ROLLING_OFFER]?: Offer[];
      }
    | undefined
  >(undefined);

  clear = () => {
    this.openBlockIndex.set(undefined);
    this.openItemIndex.set(undefined);
    this.storeOffers.set(undefined);
    this.hasStoreOffers.set(false);
  };

  setOpenBlockIndex = (index: number | undefined) => {
    this.openBlockIndex.set(index);
    // Close any open items when a block is closed
    if (index === undefined) {
      this.openItemIndex.set(undefined);
    }
  };

  setOpenItemIndex = (itemKey: string | undefined) =>
    this.openItemIndex.set(itemKey);

  setStoreOffers = (
    offers:
      | {
          [OfferType.BUNDLE]?: Offer[];
          [OfferType.SPECIAL_OFFER]?: Offer[];
          [OfferType.ROLLING_OFFER]?: Offer[];
        }
      | undefined
  ) => this.storeOffers.set(offers);

  setHasStoreOffers = (hasStoreOffers: boolean) =>
    this.hasStoreOffers.set(hasStoreOffers);
}

export const gamePortalPagesStateService = new GamePortalPagesStateService();
